import request from '@u/request'

// 上传图片
export function upload_image(data){
	return request({
		headers:{
			'Content-Type':'application/x-www-form-urlencoded'
		},
		url: '/cms/upload_image',
		method: 'POST',
		data: data || {}
	})
}


// 行业调研列表
export function research_card_list(data){
	return request({
		url: '/cms_research_card/list',
        method: 'POST',
        data: data || {}
	})
}
// 行业调研查询
export function research_card_get(data){
	return request({
		url: '/cms_research_card/get',
        method: 'POST',
        data: data || {}
	})
}
// 行业调研添加or修改
export function research_card_update(data){
	return request({
		url: '/cms_research_card/update',
        method: 'POST',
        data: data || {}
	})
}
// 行业调研删除
export function research_card_remove(data){
	return request({
		url: '/cms_research_card/remove',
        method: 'POST',
        data: data || {}
	})
}

// 课程联报列表
export function joint_course_list(data){
	return request({
		url: '/cms_joint_course/list',
        method: 'POST',
        data: data || {}
	})
}
// 课程联报修改获取数据
export function joint_course_edit(data){
	return request({
		url: '/cms_joint_course/edit',
        method: 'POST',
        data: data || {}
	})
}
// 课程联报提交数据
export function joint_course_editdo(data){
	return request({
		url: '/cms_joint_course/editdo',
        method: 'POST',
        data: data || {}
	})
}

// 线上基础班----用户列表
export function userinfoList(data){
	return request({
		url: '/cms_online/userinfoList',
        method: 'POST',
        data: data || {}
	})
}

// 线上基础班----查询用户
export function getUserinfo(data){
	return request({
		url: '/cms_online/getUserinfo',
        method: 'POST',
        data: data || {}
	})
}

// 线上基础班----添加用户
export function addUserinfo(data){
	return request({
		url: '/cms_online/addUserinfo',
        method: 'POST',
        data: data || {}
	})
}

// 线上基础班----修改用户
export function updateUserinfo(data){
	return request({
		url: '/cms_online/updateUserinfo',
        method: 'POST',
        data: data || {}
	})
}

// 线上基础班----删除用户
export function deleteUserinfo(data){
	return request({
		url: '/cms_online/deleteUserinfo',
        method: 'POST',
        data: data || {}
	})
}

// 线上基础班----导入用户
export function addUserinfoList(data){
	return request({
		url: '/cms_online/addUserinfoList',
        method: 'POST',
        data: data || {}
	})
}

// 线上基础班----班级列表
export function getClassname(data){
	return request({
		url: '/cms_online/getClassname',
        method: 'POST',
        data: data || {}
	})
}

// 线上基础班----组号列表
export function getGroupno(data){
	return request({
		url: '/cms_online/getGroupno',
        method: 'POST',
        data: data || {}
	})
}